import { render, staticRenderFns } from "./ProjectResponds.vue?vue&type=template&id=e3140556"
import script from "./ProjectResponds.vue?vue&type=script&lang=ts"
export * from "./ProjectResponds.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports